// extracted by mini-css-extract-plugin
export var actionPlaceholder = "_7t-3";
export var contentContainer = "_7t-0";
export var editorContainer = "_7t-1";
export var quillInputForm = "_7t-2";
export var zoneDivider = "_7t-4";